import { PERMISSIONS_TRANSLATIONS } from "../translations/util";

export const PERMISSION_DENIED_HEADER = PERMISSIONS_TRANSLATIONS.header;

export const permissionDeniedSubtext = ({
  module,
  operation = "view",
}: {
  module: string;
  operation?: string;
}) => {
  return PERMISSIONS_TRANSLATIONS.subtext(operation, module);
};
